export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    tagline: 'For solo founders validating an idea',
    monthly: 0,
    yearly: 0,
    cta: 'Start for free',
    highlighted: false,
    features: [
      '1 published page',
      'Core component library',
      'Community support',
      'Solvora watermark',
      'Manual deploys',
    ],
  },
  {
    id: 'growth',
    name: 'Growth',
    tagline: 'For teams shipping a real launch',
    monthly: 29,
    yearly: 290,
    cta: 'Start free trial',
    highlighted: true,
    features: [
      'Unlimited pages',
      'Full component library',
      'Custom domain',
      'CMS-powered Insights blog',
      'Priority email support',
      'Remove watermark',
    ],
  },
  {
    id: 'scale',
    name: 'Scale',
    tagline: 'For products with real growth targets',
    monthly: 79,
    yearly: 790,
    cta: 'Talk to sales',
    highlighted: false,
    features: [
      'Everything in Growth',
      'Multi-brand theming',
      'Advanced analytics',
      'SSO for your team',
      'Dedicated launch support',
      '99.9% uptime SLA',
    ],
  },
];

export const comparisonRows = [
  { label: 'Published pages', starter: '1', growth: 'Unlimited', scale: 'Unlimited' },
  { label: 'Component library', starter: 'Core', growth: 'Full', scale: 'Full' },
  { label: 'Custom domain', starter: false, growth: true, scale: true },
  { label: 'Insights CMS blog', starter: false, growth: true, scale: true },
  { label: 'Multi-brand theming', starter: false, growth: false, scale: true },
  { label: 'SSO', starter: false, growth: false, scale: true },
  { label: 'Support', starter: 'Community', growth: 'Priority email', scale: 'Dedicated' },
  { label: 'Uptime SLA', starter: false, growth: false, scale: '99.9%' },
];
